/* Sample box drawer.

   Card layout is set with INLINE styles, not the stylesheet. The theme
   overrides display on buttons, which made each card stop being its own box:
   its image and title were laid out by the parent grid instead, giving a
   column of images with the titles orphaned underneath. Inline wins. */
(function () {
  var cache = null, cfg = null, el = {}, failed = false, loading = false;

  var CARD = 'display:flex;flex-direction:column;align-items:stretch;text-align:left;' +
             'min-height:150px;padding:0;background:#fff;border:1px solid #E1DBD0;' +
             'overflow:hidden;cursor:pointer;font:inherit;color:#14120F;';
  var CARD_ON = 'box-shadow:inset 0 0 0 2px #A5194B;border-color:#A5194B;cursor:default;';
  var IMG  = 'display:block;width:100%;height:100px;object-fit:contain;background:#fff;' +
             'padding:8px;margin:0;flex:0 0 auto;';
  var NAME = 'display:block;flex:1 1 auto;padding:9px 10px 11px;font-size:12px;' +
             'font-weight:600;line-height:1.25;';

  function conf() {
    if (cfg) return cfg;
    var t = document.querySelector('[data-cro-box-config]');
    try { cfg = JSON.parse(t.textContent); } catch (e) { cfg = {}; }
    return cfg;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }
  function load() {
    if (cache) return Promise.resolve(cache);
    loading = true;
    return window.croBoxData(conf(), function (more) {
      cache = more;
      window.croBox.keepOnly(cache.map(function (s) { return s.h; }));
      if (el.root && !el.root.hidden) draw();
    }).then(function (res) {
      cache = res.list; loading = false;
      window.croBox.keepOnly(cache.map(function (s) { return s.h; }));
      return cache;
    }).catch(function () { failed = true; loading = false; cache = []; return cache; });
  }

  function skeleton(n) {
    var out = '';
    for (var i = 0; i < (n || 8); i++) {
      out += '<span class="cro-box__sk" style="display:block;min-height:150px"></span>';
    }
    return out;
  }

  function card(s) {
    var on = window.croBox.has(s.h);
    return '<button type="button" class="cro-box__i' + (on ? ' is-on' : '') + '"' +
      ' data-box-pick="' + esc(s.h) + '"' + (on ? ' disabled' : '') +
      ' style="' + CARD + (on ? CARD_ON : '') + '">' +
      '<img src="' + esc(s.i || '') + '" alt="" loading="lazy" style="' + IMG + '">' +
      '<span style="' + NAME + (on ? 'color:#A5194B;' : '') + '">' + esc(s.t) + '</span>' +
      '</button>';
  }

  function build() {
    if (el.root) return el.root;
    var d = document.createElement('div');
    d.className = 'cro-box';
    d.hidden = true;
    d.innerHTML =
      '<div class="cro-box__veil" data-box-close></div>' +
      '<aside class="cro-box__panel" role="dialog" aria-modal="true" aria-label="Your sample box">' +
        '<header class="cro-box__top">' +
          '<div><strong data-box-count></strong><span data-box-sub></span></div>' +
          '<button type="button" class="cro-box__x" data-box-close aria-label="Close">&times;</button>' +
        '</header>' +
        '<div class="cro-box__slots" data-box-slots></div>' +
        '<p class="cro-box__how">' +
          '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" ' +
          'stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M9 11.5V6.2a1.7 1.7 0 0 1 3.4 0v4.6"/>' +
          '<path d="M12.4 10.4a1.6 1.6 0 0 1 3.2 0v1"/>' +
          '<path d="M15.6 11.1a1.6 1.6 0 0 1 3.2 0v3.3a6 6 0 0 1-6 6h-1a5 5 0 0 1-3.6-1.5l-3-3.1a1.6 1.6 0 0 1 2.2-2.3L9 15.1"/>' +
          '</svg><span>Tap a scent to add it. Tap a name above to remove it.</span></p>' +
        '<input type="search" class="cro-box__q" data-box-q placeholder="Search all scents…" aria-label="Search scents">' +
        '<div class="cro-box__list" data-box-list>' + skeleton(8) + '</div>' +
        '<p class="cro-box__more" data-box-more hidden></p>' +
        '<footer class="cro-box__foot">' +
          '<p class="cro-box__note" data-box-note hidden></p>' +
          '<button type="button" class="cro-box__add" data-box-add disabled></button>' +
        '</footer>' +
      '</aside>';
    document.body.appendChild(d);
    el.root = d;
    el.count = d.querySelector('[data-box-count]');
    el.sub = d.querySelector('[data-box-sub]');
    el.slots = d.querySelector('[data-box-slots]');
    el.list = d.querySelector('[data-box-list]');
    el.more = d.querySelector('[data-box-more]');
    el.note = d.querySelector('[data-box-note]');
    el.add = d.querySelector('[data-box-add]');

    d.addEventListener('click', function (e) {
      if (e.target.closest('[data-box-close]')) { close(); return; }
      var r = e.target.closest('[data-box-rm]');
      if (r) { window.croBox.remove(r.getAttribute('data-box-rm')); draw(); return; }
      var a = e.target.closest('[data-box-pick]');
      if (a) { pick(a.getAttribute('data-box-pick')); }
    });
    d.querySelector('[data-box-q]').addEventListener('input', function () {
      draw(this.value.trim().toLowerCase());
    });
    el.add.addEventListener('click', submit);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return d;
  }

  function pick(h) {
    var r = window.croBox.add(h);
    if (r === 'full') { flash('That is ' + window.croBox.max + ' already. Remove one to swap.'); return; }
    draw();
  }
  function flash(m) {
    if (!el.note) return;
    el.note.textContent = m;
    el.note.hidden = false;
    setTimeout(function () { el.note.hidden = true; }, 2600);
  }
  function nameOf(h) {
    var s = (cache || []).filter(function (x) { return x.h === h; })[0];
    if (s) return s.t;
    return h.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function draw(q) {
    var picks = window.croBox.read(), max = window.croBox.max;
    var limit = parseInt(conf().limit, 10) || 20;
    var full = conf().full || '/products/scent-samples';

    el.count.textContent = picks.length + ' of ' + max + ' chosen';
    el.sub.textContent = picks.length === max ? 'Box is full.' : 'Pick ' + (max - picks.length) + ' more.';

    var slots = '';
    for (var i = 0; i < max; i++) {
      slots += picks[i]
        ? '<button type="button" class="cro-box__slot is-on" data-box-rm="' + esc(picks[i]) +
          '" aria-label="Remove ' + esc(nameOf(picks[i])) + '">' + esc(nameOf(picks[i])) + '</button>'
        : '<span class="cro-box__slot"></span>';
    }
    el.slots.innerHTML = slots;

    if (loading && !cache) {
      el.list.innerHTML = skeleton(8);
      el.more.hidden = true;
      el.add.textContent = 'Finding scents\u2026';
      return;
    }

    if (failed) {
      el.list.innerHTML = '<p class="cro-box__empty">The scent list could not be loaded. ' +
        '<a href="' + esc(full) + '">Build your box here instead</a>.</p>';
      el.more.hidden = true;
      el.add.disabled = true;
      el.add.textContent = 'Unavailable';
      return;
    }

    var matched = (cache || []).filter(function (s) {
      return !q || s.t.toLowerCase().indexOf(q) > -1;
    });
    var shown = q ? matched : matched.slice(0, limit);

    el.list.innerHTML = shown.length
      ? shown.map(card).join('')
      : '<p class="cro-box__empty">No scent by that name. Try part of the word.</p>';

    if (!q && matched.length > limit) {
      el.more.innerHTML = 'Showing ' + limit + ' of ' + matched.length + ' scents. ' +
        '<a href="' + esc(full) + '">See them all</a>';
      el.more.hidden = false;
    } else {
      el.more.hidden = true;
    }

    el.add.disabled = picks.length !== max;
    el.add.textContent = picks.length === max
      ? 'Add box to bag \u2014 ' + (conf().price || '')
      : 'Pick ' + (max - picks.length) + ' more';
  }

  function submit() {
    var picks = window.croBox.read(), props = {};
    picks.forEach(function (h, i) { props['Scent ' + (i + 1)] = nameOf(h); });
    el.add.disabled = true;
    el.add.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(conf().variant), quantity: 1, properties: props }] })
    }).then(function (r) {
      if (!r.ok) throw new Error();
      window.croBox.clear();
      window.location = '/cart';
    }).catch(function () {
      el.add.disabled = false;
      flash('Sorry, that could not be added.');
      draw();
    });
  }

  function open(seed) {
    build().hidden = false;
    document.body.style.overflow = 'hidden';
    draw();
    load().then(function () {
      if (seed && !window.croBox.has(seed)) pick(seed); else draw();
    });
  }
  function close() {
    if (el.root) el.root.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-box-open]');
    if (!b) return;
    e.preventDefault();
    open(b.getAttribute('data-box-open') || null);
  });
  document.addEventListener('box:changed', function () {
    if (el.root && !el.root.hidden) draw();
  });
})();
